import React, { Fragment, useEffect } from "react";
import { logout } from "../../../actions/auth";
import { connect } from "react-redux";
import { SITE_URL } from "../../../actions/types";
import { Link } from "react-router-dom";
import swal from "sweetalert";

export const Header = ({ logout }) => {
  useEffect(() => {
    localStorage.removeItem("sidebarmenu");
  }, []);

  const handleLogout = async () => {
    document.body.classList.add("swal-open-modal");
    const willLogout = await swal({
      text: "Are you sure you want to logout?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willLogout) {
      document.body.classList.remove("swal-open-modal");
      logout();
    }
  };

  return (
    <Fragment>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        {/* Sidebar Toggle (Topbar) */}
        <button
          id="sidebarToggleTop"
          onClick={() => {
            var element = document.querySelector("#accordionSidebar");
            var ele = document.querySelector("#content-wrapper");
            element.classList.toggle("toggled");
            if (!ele.classList.contains("hide-body")) {
              ele.classList.add("hide-body");
            } else {
              ele.classList.remove("hide-body");
            }
          }}
          className="btn btn-link rounded-circle mr-3"
        >
          <i className="fa fa-bars" />
        </button>
        {/* Topbar Navbar */}
        <ul className="navbar-nav ml-auto">
          <div className="topbar-divider d-none d-sm-block" />
          {/* Nav Item - User Information */}
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                Admin
              </span>
              <img
                className="img-profile rounded-circle"
                src={`${SITE_URL}/img/undraw_profile.svg`}
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                  e.target.src = "img/noImage.png"; // Fallback image if loading fails
                }}
              />
            </a>
            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <Link className="dropdown-item" to={`/change-password`}>
                <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
                Change Password
              </Link>

              <div className="dropdown-divider" />
              <a
                className="dropdown-item"
                href="/admin-login"
                onClick={(e) => {
                  e.preventDefault();

                  handleLogout();
                  // logout();
                }}
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* <div className="container">
      <div className="row">
        <div className="col-xs-3">
          <a className="mobile-nav">Dashboard</a>
        </div>
        <div className="col-xs-3">
          <a className="mobile-nav">Users</a>
        </div>
        <div className="col-xs-3">
          <a className="mobile-nav">Reports</a>
        </div><div className="col-xs-3">
          <a className="mobile-nav">Settings</a>
        </div>
      </div>
    </div>
     */}
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Header);
